export const DEFAULT_GAS_LIMIT = 580_000n
